import React from 'react'
import { CSSTransition } from 'react-transition-group'

import CompareProperty from '@components/compare-property'

import { useCompareProperty } from '@adUtilities/components/compare-property/utils'

interface PropertyCompareTransitionWrapperProps {
  children: React.ReactNode
  isConnected: boolean
  comparePropertyProps: ReturnType<typeof useCompareProperty>
  showInfo: boolean
  onFullScreenToggle: (status: boolean) => void
  onPropertyInfoToggle: (status: boolean) => void
}

const TRANSITION_TIMEOUT = 500
const TRANSITION_TIMEOUT2 = 300
const TRANSITION_CLASSNAME = 'transition-property-compare-v2'
const TRANSITION_CLASSNAME2 = 'transition-property-uncompare-v2'

function PropertyCompareTransitionWrapper({
  children,
  isConnected,
  comparePropertyProps,
  showInfo,
  onFullScreenToggle,
  onPropertyInfoToggle,
}: PropertyCompareTransitionWrapperProps) {
  const { compareModeIsActive } = comparePropertyProps
  return (
    <>
      <CSSTransition
        timeout={compareModeIsActive ? TRANSITION_TIMEOUT : 0}
        in={compareModeIsActive}
        classNames={TRANSITION_CLASSNAME}
        mountOnEnter
        unmountOnExit
      >
        <div className="h-full w-full flex-1">
          <CompareProperty
            comparePropertyProps={comparePropertyProps}
            showPropertyInfo={showInfo}
            onFullScreenToggle={onFullScreenToggle}
            onPropertyInfoToggle={onPropertyInfoToggle}
            disableIdleTimeHandler={isConnected}
            hideControls={isConnected}
          />
        </div>
      </CSSTransition>
      <CSSTransition
        timeout={!compareModeIsActive ? TRANSITION_TIMEOUT2 : 0}
        in={!compareModeIsActive}
        classNames={TRANSITION_CLASSNAME2}
        mountOnEnter
        unmountOnExit
      >
        {children}
      </CSSTransition>
    </>
  )
}

export default PropertyCompareTransitionWrapper
